export const getFileLink = {
  fileId: 'file_1OKeflKdZ3YHmMQbR18PocNa',
  fileName: 'Receipt.jpg',
  fileType: 'image/jpeg',
  fileUrl:
    'https://s3.amazonaws.com/incentdev/d2776d2a-33ae-4f3b-8091-34cad2e69fdc/s/Basic%20Item_4b6e2a810851478ba9fcc0964220c9ba.png',
};
